import { getBodyElement } from "../../../exports/dom";
import { onInit } from "../../../exports/tracking";
import { instrument } from "../../../exports/apm";
import { loggerScope } from "../parser/utils.js";
import { getTrackableElements } from "../parser/elements.js";
import { withInitLock } from "./defer.js";
import { registerTrackingHandler, unregisterTrackingHandler } from "./register.js";

const log = loggerScope.scope("init");

/*                                                                     */
export const observer = new MutationObserver((mutations) => {
  const validMutations = mutations.filter((m) => m.type === "childList");

  log.info("Processing valid mutations", validMutations.length);
  validMutations.forEach((mutation) => {
    /*                                                                          */
    const [addedNodes, removedNodes] = [[...mutation.addedNodes], [...mutation.removedNodes]];

    const elementsToTrack = getTrackableElements(addedNodes);
    log.debug("Elements to track from added nodes", elementsToTrack);
    elementsToTrack.forEach((e) => withInitLock(e, registerTrackingHandler));

    const removedElements = getTrackableElements(removedNodes);
    log.debug("Elements to unregister from removed nodes", removedElements);
    removedElements.forEach(unregisterTrackingHandler);
  });
});

/**
 *
 *
 *
 *
 *
 */
export const initDataTracker = instrument(
  async function (this): Promise<void> {
    log.info("Initialize tracking system");

    /*                                            */
    /*                                                  */
    /*                          */
    await Promise.race([
      new Promise<void>((r) => setTimeout(r, 1000)),
      new Promise<void>((r) => onInit.sub(r, { once: true })),
    ]);

    log.info("Bootstrap tracking system");
    /*                                                           */
    /*                                                             */
    const theBody = getBodyElement();
    const elementsToTrack = getTrackableElements([theBody]);

    log.info("Registering elements for tracking", elementsToTrack.length);
    elementsToTrack.forEach((e) => withInitLock(e, registerTrackingHandler));

    /*                                            */
    this?.addLabels({ gr_tracking_element_count: elementsToTrack.length });

    log.info("initialize Mutation Observer for tracking");
    observer.observe(theBody, { childList: true, subtree: true });
  },
  "Init Tracking Wrapper",
  "module-init.global-resources.tracking",
);
